import PropTypes from 'prop-types'
import { View } from './View'
import { useEffect, useState } from 'react'
import { toaster } from '@appkit4/react-components/notification'

/**
 * Appkit4 PopAlertコンポーネントは
 * <a href="https://appkit.pwc.com/appkit4/content/notification?version=react" target="_blank">こちら</a>
 *
 * showPopAlert 関数を使用することで、任意のタイミングで表示できる<br>
 * ※ 使用方法は withButton のコード参照
 */
export const PopAlert = ({ timer, ...props }) => {
    const [show, setShow] = useState(true)
    useEffect(() => {
        if (timer) {
            setTimeout(() => setShow(false), timer)
        }
    }, [])
    return show ? <View {...props} timer={timer} /> : <></>
}

export const showPopAlert = (props) => {
    const position = props.position || 'topLeft'
    toaster.notify(<PopAlert {...props} />, { position })
}

PopAlert.propTypes = {
    /**
     * ステータスアイコン<font color="red">*</font>
     */
    status: PropTypes.oneOf(['success', 'warning', 'error']).isRequired,
    /**
     * メッセージ<font color="red">*</font>
     */
    message: PropTypes.node.isRequired,
    /**
     * 表示時間（ミリ秒）
     */
    timer: PropTypes.number,
    /**
     * 表示位置
     * ※ 'topHeader' はスタイルが大きく変わってしまうので使用しない
     */
    position: PropTypes.oneOf([
        'topLeft',
        'bottomLeft',
        'topRight',
        'bottomRight',
        'topCenter',
        'bottomCenter',
        'center',
        'static'
    ]),
    /**
     * スタイル変更用のクラス名
     */
    className: PropTypes.any
}

PopAlert.defaultProps = {
    position: 'topLeft'
}
